import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { MdMoreHoriz } from 'react-icons/md';
import UserModal from '../../../Modals/UserModal/UserModal';
import ConfirmPopOver from '../../../../components/common/ConfirmPopOver';

function UserListItem(props) {
	const { user, /* onClose, */ reload, deleteUser } = props;
	const [showUserModal, setModalShow] = useState(false);
	const { t } = useTranslation();
	const currentUser = useSelector(state => state.user.data);
	const isCurrentUser = user.userID === currentUser.userID;

	const onClose = () => setModalShow(false);
	const onDelete = () => deleteUser(user);

	const DeleteItem = () => (
		<ConfirmPopOver
			placement="left"
			title={t('users.delete_user')}
			onConfirm={onDelete}
			confirmText={t('general.delete')}
			cancelText={t('general.cancel')}
			triggerElement={
				<span className="dropdown-item" style={{ cursor: 'pointer' }}>
					{t('general.delete')}
				</span>
			}
		/>
	);

	return (
		<React.Fragment>
			<div className="DataListItem row align-items-center" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
				<div className="col-lg-5">
                    <span style={{ cursor: 'pointer' }} onClick={() => setModalShow(true)}>
						<strong>{user.firstNames} {user.lastName}</strong>
					</span>
                </div>
                <div className="col-lg-3 text-left">
				{user.email}
                </div>
                <div className="col text-left">
					{user.phone}
                </div>
				<div className="col text-right">
					<Dropdown>
						<Dropdown.Toggle as="span">
							<MdMoreHoriz style={{ fontSize: '18px' }} />
						</Dropdown.Toggle>
						<Dropdown.Menu alignRight>
							<Dropdown.Item onClick={() => setModalShow(true)}>
								{t('users.show_user')}
                            </Dropdown.Item>
							{!isCurrentUser ?
								<Dropdown.Item as={DeleteItem} />
							: null}
						</Dropdown.Menu>
					</Dropdown>
				</div>
				<UserModal
					show={showUserModal}
					user={user}
					onClose={onClose}
					callback={reload}
				/>
			</div>
		</React.Fragment>
	)
}

export default UserListItem;